module.exports = __webpack_public_path__ + "static/img/icon_01.5190a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mobile/icon_01.png
// module id = k3tJ
// module chunks = 6